<script setup lang="ts">
import { toRef } from 'vue';

import VIconButton from '@components/buttons/VIconButton/VIconButton.vue';
import VCard from '@components/card/VCard/VCard.vue';
import VDownloadReportButton from '@modules/download-report/components/VDownloadReportButton/VDownloadReportButton.vue';
import { usePaymentSystemTableList } from '@modules/payment-system-details/composables';
import {
  ADMIN_PAYMENT_SYSTEM_DETAILS_REQUESTS_HISTORY_LIST_VIEW_ROUTE_NAME,
  PAYMENT_SYSTEM_DETAILS_PERMISSIONS,
  TRANSLATION_GROUP_ADMIN_PAYMENT_SYSTEM_REQUESTS_HISTORY,
} from '@modules/payment-system-details/constants';
import { EPaymentSystemsTableListType, EPaymentSystemStatus } from '@modules/payment-system-details/types';
import VTable from '@modules/tables/components/VTable/VTable.vue';

const {
  data,
  tableState,
  isLoading,
  isFetching,
  updateTableState,
  refreshTableData,
  isReportLoading,
  onDownloadReport,
  columnOptions,
  tableFilterOptions,
} = usePaymentSystemTableList(
  toRef(EPaymentSystemsTableListType.HISTORY_LIST),
);
</script>

<template>
  <VCard v-data-qa-auto-id="'PaymentSystemDetailsHistoryListPage'" type="table">
    <VTable
      :data="data"
      :title-t-path="$getTPath(TRANSLATION_GROUP_ADMIN_PAYMENT_SYSTEM_REQUESTS_HISTORY, 'REQUESTS_HISTORY_HEADER')"
      :filter-props="tableFilterOptions"
      :loading="isLoading"
      :is-fetching="isFetching"
      :state="tableState"
      :columns-options="columnOptions"
      @state-update="updateTableState"
      @refresh="refreshTableData"
    >
      <template #recordAction="{ listItem }">
        <VIconButton
          v-if="$hasPermission(PAYMENT_SYSTEM_DETAILS_PERMISSIONS.SHOW)"
          icon="pi-id-card"
          :to="{ name: ADMIN_PAYMENT_SYSTEM_DETAILS_REQUESTS_HISTORY_LIST_VIEW_ROUTE_NAME, params: { id: listItem.id } }"
        />
      </template>
      <template #footerButtons>
        <VDownloadReportButton
          v-if="$hasPermission(PAYMENT_SYSTEM_DETAILS_PERMISSIONS.HISTORY_DOWNLOAD_LIST)"
          :label="$getTranslation(TRANSLATION_GROUP_ADMIN_PAYMENT_SYSTEM_REQUESTS_HISTORY, 'DOWNLOAD_REPORT')"
          :loading="isReportLoading"
          @download="onDownloadReport"
        />
      </template>
      <template #column:status="{ value }">
        <PTag
          :value="value"
          :severity="value === EPaymentSystemStatus.APPROVED ? 'success' : value === EPaymentSystemStatus.REJECTED ? 'danger' : 'info'"
        />
      </template>
    </VTable>
  </VCard>

  <RouterView
    v-slot="{ Component }"
    name="PaymentSystemDetailsView"
  >
    <component
      :is="Component"
      :locale-key="data?.locale_key"
    />
  </RouterView>
</template>
